export interface listGroupKey {
  activeListId: Readonly<globalThis.Ref<string | number | undefined>>;
  handleUpdateActive: (id: string) => void;
}

export const listGroupInjectionKey = Symbol() as InjectionKey<listGroupKey>;
